module.exports = __webpack_public_path__ + "static/3-770a8b56c8f21711a400f7923b312e54.woff2";